import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold mb-4">ROCK GRANITES</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Premium Indian granite exporter serving international markets with quality, consistency, and reliability.
            </p>
            {/* Star Export House Badge */}
            <div className="inline-flex items-center gap-2 border border-amber-500/60 rounded px-3 py-1.5 bg-amber-500/10">
              <span className="text-amber-400 text-sm">★</span>
              <div>
                <div className="text-amber-300 text-xs font-bold tracking-wider uppercase">A Star Export House</div>
                <div className="text-amber-500/70 text-[10px] tracking-wide">DGFT · Govt. of India</div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/technical" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Technical Details
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Export Markets */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">Export Markets</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Vietnam
              </li>
              <li>Turkey
              </li>
              <li>Morocco
              </li>
              <li>Egypt</li>
              <li></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-4 text-gray-300">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={16} className="text-gray-400 mt-1 flex-shrink-0" />
                <a href="mailto:admin@rockgranites.in" className="text-sm text-gray-400 hover:text-white transition-colors">

                  admin@rockgranites.in
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={16} className="text-gray-400 mt-1 flex-shrink-0" />
                <span className="!text-sm text-gray-400">+91 9829070404</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-gray-400 mt-1 flex-shrink-0" />
                <span className="!text-sm text-gray-400">Kishangarh, Ajmer, Rajasthan, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} Rock Granites. All rights reserved. Premium Indian Granite Exporter.
          </p>
        </div>
      </div>
    </footer>);
};

export default Footer;